import { useResponsiveContext } from '@psl/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import {
  ActivityIndicator,
  StyleProp,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
  ViewProps,
  ViewStyle,
} from 'react-native';

export type CenterTouchableProps = TouchableOpacityProps & {
  direction?: 'horizontal' | 'vertical';
  loading?: boolean;
  indicatorSize?: 'small' | 'large';
  href?: string;
  target?: HTMLAnchorElement['target'];
  indicatorStyle?: StyleProp<ViewStyle>;
  indicatorColor?: string;
};

export const Center: FC<ViewProps> & {
  Touchable: FC<CenterTouchableProps>;
} = memo(({ style, children, ...props }: ViewProps) => {
  return (
    <View
      style={style}
      {...props}
      css={`
        justify-content: center;
        align-items: center;
      `}
    >
      {children}
    </View>
  );
}) as any;

Center.Touchable = memo(
  ({
    style,
    children,
    direction = 'vertical',
    loading,
    indicatorColor,
    indicatorSize = 'small',
    indicatorStyle,
    target,
    ...props
  }: CenterTouchableProps) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        style={style}
        {...props}
        {...(target ? { hrefAttrs: { target } } : {})}
        css={`
          justify-content: center;
          align-items: center;
          flex-direction: ${direction === 'vertical' ? 'column' : 'row'};
        `}
      >
        {loading ? (
          <ActivityIndicator
            size={indicatorSize}
            color={indicatorColor}
            style={[{ marginRight: children ? rpx(4) : 0 }, indicatorStyle]}
          />
        ) : null}
        {children}
      </TouchableOpacity>
    );
  },
);
